export default "__VITE_ASSET__DXpRxSZt__"